import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useLoading } from '../context/LoadingContext';
import './PageLoader.css'; // We'll create this CSS file

const PageLoader = () => {
  const { isLoading } = useLoading();

  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          className="page-loader"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          {/* This uses the same GIF from your public folder */}
          <img src="/Apex-pre-load.gif" alt="Loading..." />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageLoader;